import { render, staticRenderFns } from "./OTPModal.vue?vue&type=template&id=44c2cd0b&scoped=true"
import script from "./OTPModal.vue?vue&type=script&lang=js"
export * from "./OTPModal.vue?vue&type=script&lang=js"
import style0 from "./OTPModal.vue?vue&type=style&index=0&id=44c2cd0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c2cd0b",
  null
  
)

export default component.exports